import { ActionIcon, type ActionIconProps } from '@mantine/core';
import { IconBackspace, IconTrash } from '@tabler/icons-react';

import type { PhoneNumber } from './ClientMultiPhoneInput';
import type { EmailAddress } from './MultiEmailInputDefault';
import type { IbanBicPair } from './MultiIbanBicInput';

type FieldRemoveControlProps = {
  data: Array<EmailAddress | IbanBicPair | PhoneNumber | string>;
  disabled?: boolean;
  onClear: () => void;
  onRemove: () => void;
} & ActionIconProps;

export const FieldRemoveControl = ({
  data,
  disabled = false,
  onClear,
  onRemove,
  ...props
}: FieldRemoveControlProps) => {
  const hasOneItem = data.length <= 1;

  const handleClick = () => {
    if (hasOneItem) {
      onClear();
    } else {
      onRemove();
    }
  };

  return (
    <ActionIcon variant="subtle" color="red" onClick={handleClick} disabled={disabled} {...props}>
      {hasOneItem ? <IconBackspace size={16} /> : <IconTrash size={16} />}
    </ActionIcon>
  );
};
